import React, { useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import { svgs } from '../assets/svgs';
import { tracking } from '../utils/tracking';

const pages = [
   { name: 'overview', link: '/', trackingId: 250, },
   { name: 'investors', link: 'speakers', trackingId: 252, },
   { name: 'startups', link: 'startups', trackingId: 251, },
   // { name: 'innovators' },
   { name: 'agenda', link: 'agenda', trackingId: 253, },
   { name: 'partners', link: 'partners', trackingId: 254, },
   // { name: 'venue', link: 'venue', trackingId: 255, },
]

const dropdown = [
   { name: 'Apply to Present', link: 'startups', trackingId: 251, },
   { name: 'Featured Companies', link: 'top-innovators', trackingId: 367, },
]

export const NavBar = () => {
   const [isMenuOpen, setIsMenuOpen] = useState(false)
   const [isDDOpen, setIsDDOpen] = useState(false)


   return (
      <div className='nav-bar' onBlur={() => { window.innerWidth > 1100 && setIsDDOpen(false) }}>
         <section className='logo-section' >
            <Link onClick={() => { setIsMenuOpen(false); tracking(250) }} to='/'>{svgs.eventLogo}</Link>
            <div className='logo-venue'>
               <h6>Silicon Valley</h6>
               <h6>April 9th & 10th</h6>
            </div>
         </section>
         <section className={isMenuOpen ? 'nav open' : 'nav'}>
            {
               pages.map(page =>
                  <React.Fragment key={page.name}>
                     {page.name !== 'innovators' &&
                        <NavLink onClick={() => { setIsMenuOpen(false); tracking(page.trackingId) }} className='link' key={page.name} to={page.link}>{page.name}</NavLink>}
                     {page.name === 'innovators' &&
                        <div className="dropdown">
                           <button onClick={() => { setIsDDOpen(!isDDOpen) }} className='link'>{page.name}</button>
                           <div className={isDDOpen ? "dropdown-content open" : "dropdown-content"}>
                              {dropdown.map(page =>
                                 <NavLink onClick={() => { setIsMenuOpen(false); tracking(page.trackingId) }} key={page.name} to={page.link}>{page.name}</NavLink>
                              )}
                           </div>
                        </div>
                     }
                  </React.Fragment>
               )
            }
            {/* <div className='btns mobile'>
               <Link onClick={() => { setIsMenuOpen(false); tracking(256) }} className='btn' to={'registration'}>Tickets</Link>
               <Link onClick={() => { setIsMenuOpen(false); tracking(257) }} className='btn' to={'startups'}>Present</Link>
            </div> */}
         </section>
         <section className='btns desktop'>
            {/* <Link onClick={() => { setIsMenuOpen(false); tracking(256) }} className='btn' to={'registration'}>Tickets</Link>
            <Link onClick={() => { setIsMenuOpen(false); tracking(257) }} className='btn' to={'startups'}>Present</Link> */}
         </section>
         <section className='hamburger-section'>
            <button onClick={() => setIsMenuOpen(prev => !prev)}>
               {isMenuOpen ? svgs.clear : svgs.hamburger}
            </button>
         </section>
      </div >
   )
}





